import { createApp } from 'vue'
import App from './App.vue'

import { createPinia } from 'pinia'
// import 'bootstrap/dist/css/bootstrap.min.css'
import router from './router'
import '@fortawesome/fontawesome-free/css/all.css';
import './assets/style/style.css';
import './assets/style/pulse.css';
import './assets/style/tailwind.css';

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.mount('#app')
